<template>
    <v-footer padless class="mx-4 my-4" >
      <v-card flat tile width="100%" class=" text-center" color="#082543">
        <v-card-text>
          <v-btn :href="icon.link" target="_blank" v-for="(icon,index) in icons" :key="index" class="mx-4" icon >
            <v-icon size="27px" v-text="icon.icon" />
          </v-btn>
        </v-card-text>
        
        <v-divider class="mx-16"></v-divider>

        <v-card-text class="white--text body-1">
          2021 — <strong>JetLight Studio</strong>
        </v-card-text>
      </v-card>
    </v-footer>
</template>

<script>
export default {
    data() {
        return{
            icons: [
              {icon:'facebook', link:'https://www.facebook.com/JetLightstudio/'},
              {icon:'mdi-github', link:'https://github.com/JetLightStudio'},
              {icon:'mdi-linkedin', link:''},
              {icon:'mdi-instagram', link:'https://www.instagram.com/jetlightstd'},
              {icon:'mdi-youtube', link:'https://www.youtube.com/channel/UC2DyI3JV5wd9wJTAEdJ-M2g'},
      ],
        }
    }
}
</script>